<p text-medium-regular
  [ngClass]="{ 'center': center }"
  [ngStyle]="{ 'margin-bottom.px': verticalSpace, 'color': color }"
>
  <ng-content></ng-content>
</p>
